import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 1066 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1066 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\"><path d=\"M323.541333 426.666667l213.333334 213.333333 213.333333-213.333333z\" p-id=\"6283\" fill=\"#949497\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol